/* eslint-disable react/require-default-props */
import { useState } from 'react';

import { ICountryPhone } from 'utils/phone-patterns';

import { Box, Dropdown, Flex } from '@olist/united';

import { CustomLabel } from './phone-input.style';
import SignupInput from './signup-input';

type IItem = {
  value: string;
  onClick: () => void;
};

type IDropdownInput = {
  items: Array<IItem>;
  id: string;
  name: string;
  defaultValue: string;
  phoneValue: ICountryPhone;
  labelErrors?: (errors: string[]) => any;
  inputErrorStyle?: object;
  handleOnChangeInput?: () => void;
  label?: string;
  initialErrors?: Array<object>;
  handleLabel?: JSX.Element;
};

export default function PhoneInput({
  defaultValue,
  handleLabel,
  handleOnChangeInput,
  id,
  initialErrors = [],
  inputErrorStyle,
  items,
  label,
  labelErrors,
  name,
  phoneValue,
}: IDropdownInput) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <Flex flexDirection="column">
      {label && <CustomLabel htmlFor="mobile_phone">{label}</CustomLabel>}
      <Flex width={1}>
        <Box>
          <Dropdown
            id={id}
            name={name}
            isOpen={isDropdownOpen}
            onClick={(event: React.FormEvent<HTMLInputElement>) => {
              event.preventDefault();
            }}
            onOpen={() => {
              setIsDropdownOpen(true);
            }}
          >
            <Dropdown.Toggle>{defaultValue}</Dropdown.Toggle>
            <Dropdown.Menu>
              {items.map((item) => {
                return (
                  <Dropdown.Item
                    key={item.value}
                    onClick={() => {
                      setIsDropdownOpen(false);
                      item.onClick();
                    }}
                  >
                    {item.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </Box>
        <Box width={1}>
          <SignupInput
            name="mobile_phone"
            id="mobile_phone"
            placeholder={phoneValue.placeHolder}
            handleLabel={handleLabel}
            mask={phoneValue.mask}
            maxLength={phoneValue.mask.length}
            initialErrors={initialErrors}
            onBlur={() => true}
            guide={false}
            handleErrorMessages={labelErrors}
            styleOnError={inputErrorStyle}
            type="tel"
            onChange={handleOnChangeInput}
          />
        </Box>
      </Flex>
    </Flex>
  );
}
